import { Box, Flex, Stack } from '@mantine/core';
import clsx from 'clsx';
import classes from './FuelHazardStackedChart.module.css';
import { type FuelCategoryDisplay } from '@/features/wildfireSlice';

interface FuelHazardStackedChartProps {
  fuelCategories: FuelCategoryDisplay[];
  /**
   * Minimum percentage threshold to display a category
   * @default 0
   */
  minPercentageThreshold?: number;
  /**
   * Test ID for the chart container
   */
  'data-testid'?: string;
}

/**
 * A horizontal stacked bar chart displaying fuel category distribution
 */
export const FuelHazardStackedChart = ({
  fuelCategories,
  'data-testid': testId = 'fuel-hazard-stacked-chart',
}: FuelHazardStackedChartProps) => {
  if (fuelCategories.length === 0) {
    return null;
  }

  return (
    <Stack data-testid={testId} gap={0}>
      <Flex gap={0} className={classes.barRow} data-testid={`${testId}-bar`}>
        {fuelCategories.map((segment, index) => (
          <Box
            key={segment.category}
            className={clsx(classes.segment, classes[segment.category], {
              [classes.segmentFirst]: index === 0,
              [classes.segmentLast]: index === fuelCategories.length - 1,
            })}
            w={`${segment.value * 100}%`}
            data-testid={`${testId}-segment-${segment.category}`}
          />
        ))}
      </Flex>
    </Stack>
  );
};
